import script from "./icon-paypal.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-paypal.vue?vue&type=script&lang=ts&setup=true"

import "./icon-paypal.vue?vue&type=style&index=0&id=2003fd94&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2003fd94"]])

export default __exports__